import {
    Instance, Validation, Validator, ValueElement
} from "./Base";
import Decorator from "./decorators/Decorator";

export default class ValidationElement implements Instance, Validation {
    private instance: HTMLDivElement;

    private controls: {
        valueElement: ValueElement,
        eventHandler: any,
        validators: Validator[]
    }[];

    constructor(controls: {
                    valueElement: ValueElement,
                    validators: Validator[]
                }[],
                classes: string[] = []) {
        this.instance = document.createElement("div");
        this.instance.classList.add(...classes);

        const validators = controls.map((control) => control.validators).flat(1);
        validators.forEach((validator) => {
            const message = document.createElement("p");
            message.id = validator.name;
            message.style.display = "none";
            message.style.opacity = "0";
            message.innerHTML = validator.message;
            this.instance.appendChild(message);
        });

        this.controls = controls.map((current) => {
            const validationControl = {
                valueElement: current.valueElement,
                validators: current.validators,
                eventHandler: null
            };

            if (current.validators.length > 0) {
                Object.assign(validationControl, { eventHandler: () => this.isValid() });
                if (current.valueElement instanceof  Decorator) {
                    (current.valueElement.component as unknown as EventTarget).addEventListener("valueChanged", validationControl.eventHandler);
                } else {
                    current.valueElement.addEventListener("valueChanged", validationControl.eventHandler);
                }
            }

            return validationControl;
        }, []);
    }

    get element(): HTMLElement {
        return this.instance;
    }

    isValid(): boolean {
        let result = true;
        let hasBeenFocused = false;
        let parent: Element | null = null;
        this.controls.forEach((control) => {
            control.validators.forEach((validator: Validator) => {
                const message = document.getElementById(validator.name);
                if (!parent && message && message.parentElement && message.parentElement.parentElement) {
                    parent = message.parentElement.parentElement;
                }
                if (validator.isNotValid(control.valueElement.value)
                     && !hasBeenFocused)
                {
                    if (result) {
                        result = false;
                    }
                    if (message) {
                        message.style.display = "block";
                        message.style.opacity = "1";
                    }
                    hasBeenFocused = true;

                } else {
                    if (message) {
                        message.style.display = "none";
                        message.style.opacity = "0";
                    }
                }
            });
        });

        if (parent) {
            if (result) {
                (parent as Element).classList.remove("ces-input-error");
            } else {
                (parent as Element).classList.add("ces-input-error");
            }
        }
        return result;
    }

    dispose(): void {
        this.controls.forEach((control) => {
            if (!control.eventHandler) return;

            if (control.valueElement instanceof Decorator) {
                (control.valueElement.component as unknown as EventTarget).removeEventListener("valueChanged", control.eventHandler);
            } else {
                control.valueElement.removeEventListener("valueChanged", control.eventHandler);
            }
        });
    }
}
